import { useEffect, useState } from "react";
import {
  Navigate,
  Route,
  BrowserRouter as Router,
  Routes,
  useLocation,
} from "react-router-dom";
import Apps from "./components/Apps";
import Careers from "./components/Careers";
import Company from "./components/Company";
import Contact from "./components/Contact";
import ErrorBoundary from "./components/ErrorBoundary";
import EulaForm from "./components/EulaForm";
import Footer from "./components/Footer";
import GoogleVerification from "./components/GoogleVerification";
import Header from "./components/Header";
import HaContact from "./components/heatai/HaContact";
import {
  HeatAiEula,
  HeatAiFaq,
  HeatAiHome,
  HeatAiLayout,
  HeatAiPrivacyPolicy,
  HeatAiTerms,
} from "./components/heatai/HeatAi";
import Home from "./components/Home";
import NotFound from "./components/NotFound";
import Portfolio from "./components/Portfolio";
import PrivacyPolicy from "./components/PrivacyPolicy";
import Reviews from "./components/Reviews";
import {
  SecondMarriageChildSafety,
  SecondMarriageCommunityGuidelines,
  SecondMarriageEula,
  SecondMarriageFaq,
  SecondMarriageHome,
  SecondMarriageLayout,
  SecondMarriagePrivacyPolicy,
  SecondMarriageTerms,
} from "./components/secondmarriage/SecondMarriage";
import SmContact from "./components/secondmarriage/SmContact";
import Services from "./components/Services";
import TermsOfService from "./components/TermsOfService";
import Dashboard from "./Dashboard";
import { auth } from "./firebase";
import LoginPage from "./LoginPage";
import "./styles/App.css";
import "./styles/apple-polish.css";

function AppContent() {
  const [user, setUser] = useState(null);
  const location = useLocation();

  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged((authUser) => {
      setUser(authUser);
    });
    return () => unsubscribe();
  }, []);

  // Scroll to top on every route change
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  // Check if current route is the Google verification page
  const isVerificationPage =
    location.pathname === "/google5d2f6ca15383c900.html";

  // Second Marriage and Heat.ai pages ship their own nav/footer
  const isSecondMarriagePage = location.pathname.startsWith("/secondmarriage");
  const isHeatAiPage = location.pathname.startsWith("/heatai");
  const hideChrome = isVerificationPage || isSecondMarriagePage || isHeatAiPage;

  return (
    <div className="app-container">
      {!hideChrome && <Header />}

      <main className="content">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/home" element={<Home />} />
          <Route path="/company" element={<Company />} />
          <Route path="/apps" element={<Apps />} />
          <Route path="/services" element={<Services />} />
          <Route path="/portfolio" element={<Portfolio />} />
          <Route path="/reviews" element={<Reviews />} />
          <Route path="/careers" element={<Careers />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/privacypolicy" element={<PrivacyPolicy />} />
          <Route path="/termsofservices" element={<TermsOfService />} />
          <Route path="/eulaForm" element={<EulaForm />} />

          <Route path="/secondmarriage" element={<SecondMarriageLayout />}>
            <Route index element={<SecondMarriageHome />} />
            <Route
              path="privacypolicy"
              element={<SecondMarriagePrivacyPolicy />}
            />
            <Route path="termsofservices" element={<SecondMarriageTerms />} />
            <Route path="eula" element={<SecondMarriageEula />} />
            <Route
              path="communityguidelines"
              element={<SecondMarriageCommunityGuidelines />}
            />
            <Route path="child-safety" element={<SecondMarriageChildSafety />} />
            <Route path="faq" element={<SecondMarriageFaq />} />
            <Route path="contact" element={<SmContact />} />
          </Route>
          <Route path="/heatai" element={<HeatAiLayout />}>
            <Route index element={<HeatAiHome />} />
            <Route path="privacypolicy" element={<HeatAiPrivacyPolicy />} />
            <Route path="termsofservices" element={<HeatAiTerms />} />
            <Route path="eula" element={<HeatAiEula />} />
            <Route path="faq" element={<HeatAiFaq />} />
            <Route path="contact" element={<HaContact />} />
          </Route>

          {/* <Route path="/partners" element={<Partners />} /> */}

          <Route
            path="/google5d2f6ca15383c900.html"
            element={<GoogleVerification />}
          />

          <Route path="/login" element={<LoginPage />} />
          <Route
            path="/admin/dashboard"
            element={user ? <Dashboard /> : <Navigate to="/login" replace />}
          />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </main>

      {!hideChrome && <Footer />}
    </div>
  );
}

function App() {
  return (
    <ErrorBoundary>
      <Router>
        <AppContent />
      </Router>
    </ErrorBoundary>
  );
}

export default App;
